// extracted by mini-css-extract-plugin
export default {"floating":"styles_floating__4prX-","shrink":"styles_shrink__mzu5Q"};